<template>
	<Pupup :showClose="true" title="How can we help with your collab?" :width="1400" :full="false" :clickOverlayToClose="false" @close="handleClose">
		<template #content>
			<div class="start-campaign-flow">
				<div class="collab-help-layout">
					<div class="collab-help-column">
						<h3 class="collab-help-title underline"><span>I've never done a collab before</span></h3>
						<div class="choice-card" @click.stop="handleReadGuide">
							<div class="choice-visual choice-visual--feature" aria-hidden="true"></div>

							<div class="choice-footer">
								<button type="button" class="button ghost no-margin" @click.stop="handleReadGuide">Read the guide</button>
								<p>
									If you're new to collaborations it can feel daunting, so we've created a guide to help you confidently reach out to complementary
									brands and execute ideas.
								</p>
							</div>
						</div>
					</div>

					<div class="collab-help-column">
						<h3 class="collab-help-title underline"><span>Get some ideas!</span></h3>
						<div class="help-along">
							<ul class="help-list">
								<li class="help-item">
									<button type="button" class="help-item-button" @click="handleTakeQuiz">
										<span class="help-image" aria-hidden="true">
											<img src="./../../assets/img/quiz-small.png" alt="" loading="lazy" />
										</span>
										<span class="help-copy">
											<span class="help-item-title">Ideas generator</span>
											<span class="help-item-text">
												Take our quick collab ideas quiz and get tailored ideas for your brand.
											</span>
										</span>
									</button>
								</li>

								<li class="help-item">
									<button type="button" class="help-item-button" @click="handleGoTo('/opportunities')">
										<span class="help-image" aria-hidden="true">
											<img src="./../../assets/img/home-cooks2-small.jpeg" alt="" loading="lazy" />
										</span>
										<span class="help-copy">
											<span class="help-item-title">Opportunities area</span>
											<span class="help-item-text"> Join other brand's collaborations and get ideas for your own. </span>
										</span>
									</button>
								</li>
								<li class="help-item">
									<button type="button" class="help-item-button" @click="handleClickWritingTool">
										<span class="help-image" aria-hidden="true">
											<img src="./../../assets/img/writing-assistant-small.png" alt="" loading="lazy" />
										</span>
										<span class="help-copy">
											<span class="help-item-title"
												><Icon
													type="writing-tool"
													class="brand-connect-assistant-title-icon"
													colour="#a26c67" />
												<span>Writing Tool</span></span
											>
											<span class="help-item-text">
												Our AI writing tool knows your brand already, use it to generate ideas and craft the perfect Collab Request or Opportunity in minutes.
											</span>
										</span>
									</button>
								</li>

								<li class="help-item">
									<button type="button" class="help-item-button" @click="handleGoTo('/inspiration/member-collabs')">
										<span class="help-image" aria-hidden="true">
											<img src="./../../assets/img/members-collabs-small.jpg" alt="" loading="lazy" />
										</span>
										<span class="help-copy">
											<span class="help-item-title">Members collabs</span>
											<span class="help-item-text"> See how other PartnerUp members have been collaborating. </span>
										</span>
									</button>
								</li>
								<li class="help-item">
									<button type="button" class="help-item-button" @click="handleGoTo('/inspiration/calendar')">
										<span class="help-image" aria-hidden="true">
											<img src="./../../assets/img/doi-small.jpg" alt="" loading="lazy" />
										</span>
										<span class="help-copy">
											<span class="help-item-title">Dates of interest</span>
											<span class="help-item-text"> Spark collaboration ideas with our Dates of Interest calendar. </span>
										</span>
									</button>
								</li>
								<li class="help-item">
									<button type="button" class="help-item-button" @click="handleGoTo('/inspiration/ideas')">
										<span class="help-image" aria-hidden="true">
											<img src="./../../assets/img/collab-ideas-small.jpg" alt="" loading="lazy" />
										</span>
										<span class="help-copy">
											<span class="help-item-title">Collab Ideas</span>
											<span class="help-item-text">
												Jam packed with collab ideas, how-to guides, examples, templates and more.
											</span>
										</span>
									</button>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</template>
	</Pupup>
</template>

<script>
import { useRouter } from "vue-router";
import { useVueInstance } from "../../composables/useVueInstance";
import Pupup from "../Display/Pupup.vue";
import Icon from "../Display/BaseIcon.vue";

export default {
	name: "CollabHelp",
	components: {
		Pupup,
		Icon,
	},
	emits: ["close", "take-quiz"],
	setup(props, { emit }) {
		const router = useRouter();
		const { store, $toast } = useVueInstance();

		const handleClose = () => {
			emit("close");
		};

		const handleReadGuide = () => {
			store.commit("general/openCollabHelpNeverDonePopup", {
				source: "collab-help",
			});
			//handleClose();
		};

		const handleTakeQuiz = () => {
			emit("take-quiz");
		};

		const handleGoTo = (url) => {
			store.commit("general/closeBrandCardPopup");
			handleClose();
			router.push(url);
		};

		const handleClickWritingTool = () => {
			$toast.success("Use the Writing Tool when you create an Opportunity or send a Collab Request");
		};

		return {
			handleClose,
			handleReadGuide,
			handleTakeQuiz,
			handleGoTo,
			handleClickWritingTool
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";

.start-campaign-flow {
	padding: 0;
}

.collab-help-layout {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 18px;
	align-items: stretch;
	padding: 0 4px;
}

.collab-help-column {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.collab-help-title {
	margin: 0;
	font-size: 1.1rem;
	font-weight: @bold;
	color: @darkContrast;
	padding: 0 20px 0 0;
	margin-bottom: 5px;
}

.choice-card {
	background: #fff;
	border: 1px solid @guidedRoseBorder;
	border-radius: @radiusXl;
	padding: 18px 20px 20px;
	.elevation.card();
	display: flex;
	flex-direction: column;
	gap: 18px;
	cursor: pointer;
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease,
		border-color 0.2s ease;

	&:hover,
	&:focus {
		transform: translateY(-1px);
		.elevation.cardHover();
		border-color: @guidedRoseBorderStrong;
	}

	&:focus-visible {
		outline: 2px solid fade(@guidedRose, 45%);
		outline-offset: 2px;
	}
}

.choice-visual {
	border-radius: @radiusLg;
	border: 1px solid @guidedRoseBorder;
	background: @guidedRoseBg;
	padding: 0;
	aspect-ratio: 1 / 0.41;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1 1 auto;
	overflow: hidden;
	background: #efdedd url("../../assets/img/help-never.jpg") no-repeat 0 0;
	background-size: 105% auto;
}

.choice-footer {
	margin-top: auto;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 12px;

	h3 {
		flex: 1 1 auto;
		min-width: 0;
	}

	.button {
		flex: 0 0 auto;
		align-self: center;
		white-space: nowrap;
	}

	p {
		width: 100%;
		margin: 0;
		font-size: 0.92rem;
	}
}

.help-along {
	display: flex;
}

.help-list {
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
}

.help-item {
	display: block;
	height: 100%;
}

.help-item-content,
.help-item-button {
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: 62px 1fr;
	gap: 8px;
	align-items: center;
	align-content: center;
	text-align: left;
	padding: 8px;
	border-radius: @radiusLg;
	border: 1px solid @guidedRoseBorder;
	background: #fff;
	color: inherit;
}

.help-item-button {
	cursor: default;
	transition:
		transform 0.2s ease,
		box-shadow 0.2s ease,
		border-color 0.2s ease;

	&:not(.no-hover) {
		cursor: pointer;

		&:hover,
		&:focus {
			transform: translateY(-1px);
			.elevation.cardHover();
			border-color: @guidedRoseBorderStrong;
		}

		&:focus-visible {
			outline: 2px solid fade(@guidedRose, 45%);
			outline-offset: 2px;
		}
	}
}

.help-image {
	width: 60px;
	height: 60px;
	border-radius: @radiusCircle;
	border: 2px solid @guidedRoseBorderStrong;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	background: @guidedRoseBg;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
}

.help-copy {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.help-item-title {
	font-size: 0.95rem;
	font-weight: 800;
	color: @guidedRoseText;
	display: flex;
	align-items: center;
	gap: 4px;
	svg,
	.brand-connect-assistant-title-icon {
		width: 20px;
		height: 20px;
	}
	span {
		color: inherit;
	}
}

.help-item-text {
	font-size: 0.92rem;
	color: fade(@darkContrast, 78%);
	line-height: 1.45;
}

@media screen and (min-width: 1300px) {
	.help-list {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		align-items: stretch;
	}
	.collab-help-layout {
		grid-template-columns: minmax(0, 0.7fr) minmax(0, 1fr);
	}
}

@media screen and (max-width: 1024px) {
	.collab-help-layout {
		grid-template-columns: minmax(0, 1fr);
	}

	.choice-visual {
		background-size: auto 150%;
	}

	.choice-footer {
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;

		.button {
			align-self: flex-start;
		}
	}
}

@media screen and (max-width: 500px) {
	.choice-visual {
		background-size: 100% auto;
	}
	.collab-help-layout {
		padding: 0;
	}
}
</style>
